// extracted by mini-css-extract-plugin
export var cdStickyGrid = "sticky-module--cd-sticky-grid--1ab48";
export var cdStickyGridImg = "sticky-module--cd-sticky-grid-img--f2aaf";
export var cdStickyGridReverse = "sticky-module--cd-sticky-grid-reverse--0a3e5";
export var cdStickyGridRight = "sticky-module--cd-sticky-grid-right--53dad";
export var cdStickyGridSection = "sticky-module--cd-sticky-grid-section--2cef9";
export var cdStickyGridText = "sticky-module--cd-sticky-grid-text--baffb";
export var cdStickyGridTextWrapper = "sticky-module--cd-sticky-grid-text-wrapper--aee66";